export default __webpack_public_path__ + "static/media/traitmentAir.b5568774.jpg";